import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import Menu from '../components/menu'
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
class MaintananceGame extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMaintanance: false
        };
    }

    componentDidMount() {

    }

    updateMaintanence(status) {
        this.setState({ isMaintanance: status })
    }

    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body>
                <Header notify={this.props.notify} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateMaintanence={(status) => { this.updateMaintanence(status) }} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets maintanancegame">
                        <iframe src={BASE_IMAGE_PATH + "/games/" + this.props.match.params.game_id + "/index.html"} width="100%" height="100vh" frameBorder="0" title="3D Roulette" />
                    </div>
                </div>
            </body>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MaintananceGame);